import { Routes, UrlSegment } from '@angular/router';
import { LoginRedirectGuard } from '../guards/login-redirect.guard';
import { AuthCallbackComponent } from '../public/auth/auth-callback/auth-callback.component';
import { LoggedOutComponent } from '../public/logged-out/logged-out.component';
import { LogoutComponent } from '../secure/logout/logout.component';
import { AssetRecoveryReportComponent } from '../secure/pages/asset-recovery-report/asset-recovery-report.component';
import { RequestAccessPageComponent } from '../secure/pages/request-access/request-access-page.component';
import { SharedInvestigationComponent } from '../secure/pages/shared-investigation/shared-investigation.component';
import { TheftReportComponent } from '../secure/pages/theft-report/theft-report.component';
import { UserReportComponent } from '../secure/pages/user-report/user-report.component';
import { CaseTrackingGuestPortalComponent } from '../secure/tabs/case-tracking-guest-portal/case-tracking-guest-portal.component';
import { ReportDashboardComponent } from '../secure/tabs/report-dashboard/report-dashboard.component';
import { SharedHomeComponent } from '../shared/landing/shared-home.component';
import { getSharedRedirectUri } from '../utils';

const sharedUrlToMatchedRoute = (url: UrlSegment[], shareKeyIndex: number) => ({
  consumed: url,
  posParams: {
    shareKey: new UrlSegment(
      url
        .slice(shareKeyIndex)
        .map((url) => url.path)
        .join('/'),
      {},
    ),
  },
});

export const sharedRoutes: Routes = [
  {
    path: '',
    redirectTo: '/shared',
    pathMatch: 'full',
  },
  {
    path: 'shared',
    component: SharedHomeComponent,
    children: [
      {
        path: 'guest-cases',
        component: CaseTrackingGuestPortalComponent,
      },
      {
        path: 'guest-reports',
        component: ReportDashboardComponent,
      },
      {
        path: 'investigation/:reviewId',
        component: SharedInvestigationComponent,
        data: { redirect_uri: getSharedRedirectUri() },
      },
      {
        path: 'request-access',
        component: RequestAccessPageComponent,
      },
      {
        path: 'asset-recovery-report/:assetRecoveryId',
        component: AssetRecoveryReportComponent,
        data: { redirect_uri: getSharedRedirectUri() },
      },
      {
        matcher: (url) => {
          const isRegularSharedUrl = url.length === 2 && url[0].path === 'theft-report';
          if (isRegularSharedUrl) {
            return sharedUrlToMatchedRoute(url, 1);
          }
          return null;
        },
        component: TheftReportComponent,
        data: { redirect_uri: getSharedRedirectUri() },
      },
      {
        path: 'report/:reportId',
        component: UserReportComponent,
        data: { redirect_uri: getSharedRedirectUri() },
      },
      {
        path: 'theft-report/auth/callback',
        component: AuthCallbackComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'logged-out',
        component: LoggedOutComponent,
      },
      { path: '**', redirectTo: '/home/login' },
    ],
    canActivate: [LoginRedirectGuard],
  },
];
